import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from '@mlb/react-patterns/v4/components/AnimateHeight/animateHeight';

const CollapsibleItem = ({
    expanded,
    collapsible,
    renderVisible
}) => {
    return (
        <Fragment>
            { renderVisible }
            <AnimateHeight expanded={expanded} collapsible={collapsible} />
        </Fragment>
    );
};

CollapsibleItem.propTypes = {
    expanded: PropTypes.bool,
    collapsible: PropTypes.element,
    renderVisible: PropTypes.element
};

export default CollapsibleItem;
